import styled from "styled-components";

export const Container = styled.div`
  margin-top: 50px;
  overflow: hidden;
  @media (max-width: 768px) {
    margin: unset;
  }
`;
export const MainContainer = styled.div`
  /* display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 66px;
  grid-column-gap: 40px;
  justify-items: end; */
  display: flex;
  flex-direction: row !important;
  gap: 50px;
  /* flex-wrap: wrap; */
  -webkit-flex-direction: row;
  padding: 4em;
`;
export const LeftContainer = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
  @media (max-width: 575px) {
    display: none;
  }
`;
export const ImageContainer = styled.img`
  height: 100vh;
  object-fit: cover;
`;
export const RightContainer = styled.div``;
export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Card = styled.div`
  box-shadow: 0px 3px #00000029;
  border: 1px solid #00000029;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  opacity: 1;
  padding: 10px 32px;
`;

export const HeadingContainer = styled.div``;

export const Title = styled.h1`
  font-size: 52px;
  font-family: Poppins-SemiBold;
  color: #1d1d1d;
  text-align: center;
  margin-bottom: unset;
  padding-top: 10px;
  @media (max-width: 575px) {
    font-size: 38px;
  }
`;
export const SubTitle = styled.p`
  font-size: 28px;
  font-family: Poppins-Light;
  color: #1d1d1d;
  text-align: center;
  @media (max-width: 575px) {
    font-size: 18px;
  }
`;

export const CardHeading = styled.h3`
  font-size: 24px;
  font-family: Poppins-Medium;
  color: #f2b017;
  text-align: left;
  margin-bottom: unset;
  letter-spacing: 1.4px;
`;
export const CardDescription = styled.p`
  font-size: 14px;
  font-family: Poppins-Light;
  color: #1d1d1d;
  text-align: left;
  letter-spacing: 0.76px;
`;
